import { createRouter, createWebHistory } from "vue-router";
import LoginView from "@/views/LoginView.vue";
import DashboardView from "@/views/DashboardView.vue";
import UsersView from "@/views/user/UsersView.vue";
import UserDetailView from "@/views/user/UserDetailView.vue";
import ManagersView from "@/views/manager/ManagersView.vue";
import CategoriesView from "@/views/card/CategoriesView.vue";
import TagsView from "@/views/card/TagsView.vue";
import CardsView from "@/views/card/CardsView.vue";
import CardView from "@/views/card/CardView.vue";
import CardEditView from "@/views/card/CardEditView.vue";
import CardPacksView from "@/views/card/CardPacksView.vue";
import CardPackView from "@/views/card/CardPackView.vue";
import CardPackEditView from "@/views/card/CardPackEditView.vue";
import RechargeItemsView from "@/views/recharge/RechargeItemsView.vue";
import FeedbacksView from "@/views/user/FeedbacksView.vue";
import DrawLogsView from "@/views/card/DrawLogsView.vue";
import ExchangeView from "@/views/card/ExchangeView.vue";
import ShipLogsView from "@/views/card/ShipLogsView.vue";
import SnapshotView from "@/views/snapshot/SnapshotView.vue";
import CardFragmentsView from "@/views/card/CardFragmentsView.vue";
import CardFragmentEditView from "@/views/card/CardFragmentEditView.vue";
import CardFragmentView from "@/views/card/CardFragmentView.vue";
import { useAdminStore } from "@/stores/admin";

const routes = [
  {
    path: "/",
    component: DashboardView,
    meta: { requiresAuth: true, pageName: "首页" },
  },
  {
    path: "/login",
    component: LoginView,
    meta: { requiresAuth: false, pageName: "登录页" },
  },
  {
    path: "/dashboard",
    component: DashboardView,
    meta: { requiresAuth: true, pageName: "首页" },
  },
  {
    path: "/users",
    component: UsersView,
    meta: { requiresAuth: true, pageName: "用户列表页" },
  },
  {
    path: "/user/:id",
    component: UserDetailView,
    meta: { requiresAuth: true, pageName: "用户详情页" },
  },
  {
    path: "/managers",
    component: ManagersView,
    meta: { requiresAuth: true, pageName: "管理员列表页" },
  },
  {
    path: "/categories",
    component: CategoriesView,
    meta: { requiresAuth: true, pageName: "卡包/卡片类别页" },
  },
  {
    path: "/tags",
    component: TagsView,
    meta: { requiresAuth: true, pageName: "卡包/卡片标签页" },
  },
  {
    path: "/cards",
    component: CardsView,
    meta: { requiresAuth: true, pageName: "卡片列表页" },
  },
  {
    path: "/card/add",
    component: CardEditView,
    meta: { requiresAuth: true, pageName: "增加卡片页" },
  },
  {
    path: "/card/edit/:id",
    component: CardEditView,
    meta: { requiresAuth: true, pageName: "卡片配置修改页" },
  },
  {
    path: "/card/:id",
    component: CardView,
    meta: { requiresAuth: true, pageName: "卡片详情页" },
  },
  {
    path: "/packs",
    component: CardPacksView,
    meta: { requiresAuth: true, pageName: "卡包列表页" },
  },
  {
    path: "/pack/add",
    component: CardPackEditView,
    meta: { requiresAuth: true, pageName: "增加卡包页" },
  },
  {
    path: "/pack/edit/:id",
    component: CardPackEditView,
    meta: { requiresAuth: true, pageName: "卡包配置修改页" },
  },
  {
    path: "/pack/:id",
    component: CardPackView,
    meta: { requiresAuth: true, pageName: "卡包详情页" },
  },
  {
    path: "/fragments",
    component: CardFragmentsView,
    meta: { requiresAuth: true, pageName: "碎片列表页" },
  },
  {
    path: "/fragment/add",
    component: CardFragmentEditView,
    meta: { requiresAuth: true, pageName: "增加碎片页" },
  },
  {
    path: "/fragment/edit/:id",
    component: CardFragmentEditView,
    meta: { requiresAuth: true, pageName: "碎片修改页" },
  },
  {
    path: "/fragment/:id",
    component: CardFragmentView,
    meta: { requiresAuth: true, pageName: "碎片详情页" },
  },
  {
    path: "/recharge/items",
    component: RechargeItemsView,
    meta: { requiresAuth: true, pageName: "充值项目配置页" },
  },
  {
    path: "/feedbacks",
    component: FeedbacksView,
    meta: { requiresAuth: true, pageName: "反馈列表" },
  },
  {
    path: "/drawlogs",
    component: DrawLogsView,
    meta: { requiresAuth: true, pageName: "用户抽卡记录" },
  },
  {
    path: "/exchangelogs",
    component: ExchangeView,
    meta: { requiresAuth: true, pageName: "积分兑换记录" },
  },
  {
    path: "/ships",
    component: ShipLogsView,
    meta: { requiresAuth: true, pageName: "卡片提现记录" },
  },
  {
    path: "/snapshots",
    component: SnapshotView,
    meta: { requiresAuth: true, pageName: "数据快照" },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const adminStore = useAdminStore();

  if (adminStore.accessToken && !adminStore.admin) {
    await adminStore.getMe();
  }

  if (to.meta.requiresAuth && !adminStore.isLoggedIn) {
    next("/login");
  } else {
    next();
  }
});

export default router;
